import { useRef } from "react";
import Hero from "../Components/Hero/Hero.jsx";
import NewCollections from "../Components/NewCollections/NewCollections.jsx";
import NewsLetter from "../Components/NewsLetter/NewsLetter.jsx";
import Offers from "../Components/Offers/Offers.jsx";
import Popular from "../Components/Popular/Popular.jsx";
import Testimonials from "../Components/Testimonials/Testimonials.jsx";
import "./CSS/Shop.css";

const Shop = () => {
  const productRef = useRef(null);

  const scrollToProducts = () => {
    productRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="shop-page">
      <Hero onAllProductsClick={scrollToProducts} />
      <Popular />
      <Offers />

      {/* 👇 TARGET SECTION */}
      <div ref={productRef}>
        <NewCollections />
      </div>

      <NewsLetter />
      <Testimonials />
    </div>
  );
};

export default Shop;
